export default function phoneMask(text) {
  const textClean = text.replace(/\D/g, '');
  const textParenthesis = textClean.replace(/^(\d{2})(\d)/g, '($1) $2');
  const textPhone = textParenthesis.replace(/(\d)(\d{4})$/, '$1-$2');
  return textPhone;
}
